<!-- 
Shows disclaimer, copyright and privacy links.
-->
<template>
  <div>
    <p class="text-xs-center mt-4 mb-2">
      <a :href="disclaimerUrl" target="_blank">Disclaimer</a> <v-icon small color="primary" class="ml-1 mr-4">open_in_new</v-icon>
      <a :href="copyrightUrl" target="_blank">Copyright</a> <v-icon small color="primary" class="ml-1 mr-4">open_in_new</v-icon>
      <a :href="privacyUrl" target="_blank">Privacy</a> <v-icon small color="primary" class="ml-1 mr-4">open_in_new</v-icon>
    </p>
    <p v-if="loaded" class="text-xs-center caption mt-0" style="color: gray;">
      <v-tooltip bottom>
        <span slot="activator">{{ caption }}</span>
        <span>
          Client version: {{ clientVersion }}
          <br>
          Server version: {{ serverVersion }}
        </span>
      </v-tooltip>
    </p>
  </div>
</template>

<script>
export default {
  computed: {
    disclaimerUrl() {
      return this.$store.state.system.details.disclaimer_url;
    },
    copyrightUrl() {
      return this.$store.state.system.details.copyright_url;
    },
    privacyUrl() {
      return this.$store.state.system.details.privacy_url;
    },
    caption() {
      return this.hasClientVersion ? `v${this.clientVersion}` : `v${this.serverVersion}`;
    },
    loaded() {
      return this.$store.state.system.details.loaded;
    },
    clientVersion() {
      const version = process.env.VUE_APP_CLIENT_BUILD;
      const expectedVersion = this.$store.state.system.details.client_build;
      return version == expectedVersion ? version : `${version} (but expected ${expectedVersion})`;
    },
    serverVersion() {
      return this.$store.state.system.details.build;
    },
    hasClientVersion() {
      return this.clientVersion != "Will be set by the build";
    }
  }
};
</script>
